import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
  withWidth,
} from "@material-ui/core";
import {
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  Print as PrintIcon,
  Visibility as VisibilityIcon,
} from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import excelIcon from "src/assets/images/excelIcon.svg";
import {
  Container,
  DataGrid,
  Dialog,
  FilterBar,
  InputDate,
  InputMask,
  InputText,
  Loading,
  Modal,
  Paginate,
} from "src/components";
import {
  consultaSaldo,
  enviarCashback,
  gerarExcel,
  pesquisarCashback,
  receberCashback,
} from "src/store/actions/cashback";
import * as types from "src/store/types/cashback";
import ModalCliente from "./ModalCliente";
import ModalExtrato from "./ModalExtrato";

const DATA_SCHEMA = {
  cliente_id: "",
  cliente_nome: "",
  cliente_cpf: "",
  cep: "",
  uf: "",
  cidade: "",
  bairro: "",
  distancia: "",
};

const Cashback = ({ width }) => {
  const dispatch = useDispatch();
  const { empresa_atual } = useSelector((state) => state.usuario);
  const {
    cashback_filtro,
    cashback_page,
    cashback_perpage,
    cashback_total,
    cashback_lista,
    loading,
    cashback,
  } = useSelector((state) => state.cashback);
  const [modal, setModal] = useState({
    enviar: false,
    receber: false,
    dialog: false,
    cliente: false,
    extrato: false,
  });
  const [data, setData] = useState(DATA_SCHEMA);

  useEffect(() => pesquisar(), []);

  useEffect(() => {
    changed({
      cpf: "",
      saldo: 0,
      presentes: 0,
      valor: 0,
      numero_venda: "",
      nome: "",
      senha: "",
      tipo: 0,
    });
  }, [modal]);

  const modals = (e) => setModal({ ...modal, ...e });
  const addFilter = (filtro) =>
    dispatch({ type: types.SET_CASHBACKS_FILTRO, payload: { ...filtro } });
  const changed = (e) =>
    dispatch({ type: types.SET_CASHBACK, payload: { ...cashback, ...e } });

  function pesquisar() {
    dispatch([
      { type: types.CASHBACKS_LOADING, payload: true },
      { type: types.SET_CASHBACKS_PAGE, payload: 1 },
      pesquisarCashback({ ...cashback_filtro, page: 1, per_page: 10 }),
    ]);
  }

  function exportar() {
    gerarExcel({ ...cashback_filtro });
  }

  function limparfiltros() {
    let filter = {
      data_inicial: moment().subtract(1, "day").format("YYYY-MM-DD"),
      data_final: moment().add(1, "day").format("YYYY-MM-DD"),
      bonus: 0,
      cpf: "",
    };
    addFilter({ ...filter });
    dispatch([
      { type: types.CASHBACKS_LOADING, payload: true },
      { type: types.SET_CASHBACKS_PAGE, payload: 1 },
      pesquisarCashback({ ...filter, page: 1, per_page: 10 }),
    ]);
  }

  function handleChangePage(newPage) {
    dispatch([
      { type: types.SET_CASHBACKS_PAGE, payload: newPage + 1 },
      pesquisarCashback({
        ...cashback_filtro,
        page: newPage + 1,
        per_page: cashback_perpage,
      }),
    ]);
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.SET_CASHBACKS_PAGE, payload: 1 },
      {
        type: types.SET_CASHBACKS_PERPAGE,
        payload: parseInt(event.target.value, 10),
      },
      pesquisarCashback({
        ...cashback_filtro,
        page: 1,
        per_page: parseInt(event.target.value, 10),
      }),
    ]);
  };

  function consultar() {
    consultaSaldo(cashback.cpf).then(
      ({ nome, saldo, presentes = 0 }) => changed({ nome, saldo, presentes }),
      (error) => console.log(error)
    );
  }

  function sendCashback() {
    enviarCashback().then(
      () => {
        modals({ enviar: false, receber: false, dialog: true });
      },
      (error) => {}
    );
  }

  function recieveCashback() {
    if (cashback.tipo === 0) {
      if (parseFloat(cashback.saldo) >= parseFloat(cashback.valor)) {
        receberCashback().then(
          () => {
            modals({ enviar: false, receber: false, dialog: false });
          },
          (error) => {}
        );
      } else {
        alert("Valor não pode ser maior que o saldo disponível");
      }
    } else {
      if (parseFloat(cashback.presentes) >= parseFloat(cashback.valor)) {
        receberCashback().then(
          () => {
            modals({ enviar: false, receber: false, dialog: true });
          },
          (error) => {}
        );
      } else {
        alert("Valor não pode ser maior que o saldo disponível");
      }
    }
  }

  function renderTipo(tipo) {
    return tipo === "R" ? (
      <ArrowUpwardIcon style={{ color: "#373737" }} />
    ) : (
      <ArrowDownwardIcon style={{ color: "#cc0000" }} />
    );
  }

  function renderValor(rowData) {
    return rowData.tipo === "R" ? (
      <NumberFormat
        value={rowData.valor || 0}
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={"R$ "}
        thousandSeparator={"."}
        decimalSeparator={","}
        displayType={"text"}
        style={{ color: "#373737" }}
      />
    ) : (
      <NumberFormat
        value={rowData.valor * -1 || 0}
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={"R$ "}
        thousandSeparator={"."}
        decimalSeparator={","}
        displayType={"text"}
        style={{ color: "#cc0000" }}
      />
    );
  }

  return (
    <Container
      title="Controle de Cashback"
      buttonsRight={
        empresa_atual.cashback_dashboard == 'S' ? [
          {
            title: "Receber Cashback",
            icon: <ArrowUpwardIcon style={{ fontSize: 14, color: "#373737" }} />,
            onClick: () => modals({ receber: true }),
            style: { fontSize: 14, color: "#373737" },
          },
          {
            title: "Enviar Cashback",
            icon: (
              <ArrowDownwardIcon style={{ fontSize: 14, color: "#cc0000" }} />
            ),
            onClick: () => modals({ enviar: true }),
            style: { fontSize: 14, color: "#cc0000" },
          }
        ]:[
          {
            title: "Receber Cashback",
            icon: <ArrowUpwardIcon style={{ fontSize: 14, color: "#373737" }} />,
            onClick: () => modals({ receber: true }),
            style: { fontSize: 14, color: "#373737" },
          },
      ]}
    >
      <Loading loading={loading} />
      <Dialog
        visible={modal.dialog}
        title="Operação Realizada."
        contenttext="Operação Realizada com sucesso!"
        buttons={[
          {
            autoFocus: true,
            title: "OK",
            onClick: () => {
              modals({ dialog: false });
              pesquisar();
            },
          },
        ]}
      />
      <Modal open={modal.receber} width="900px">
        <Typography> Receber cashback </Typography>
        <Grid container>
          <Grid container item spacing={2}>
            <Grid item sm={3}>
              <InputMask
                label="CPF"
                value={cashback.cpf}
                format="###.###.###-##"
                onChange={(event) =>
                  changed({
                    cpf: event.target.value
                      .replaceAll(".", "")
                      .replace("-", ""),
                  })
                }
                onBlur={() => consultar()}
              />
            </Grid>
            <Grid item sm={5}>
              <InputText
                disabled
                label="Nome"
                value={cashback.nome}
                onChange={(event) => changed({ nome: event.target.value })}
              />
            </Grid>
            <Grid item sm={2}>
              <InputMask
                disabled
                type="cash"
                label="Saldo Cashback"
                value={cashback.saldo}
                onChange={(event) =>
                  changed({ saldo: event.target.values.floatValue })
                }
              />
            </Grid>
            <Grid item sm={2}>
              <InputMask
                disabled
                type="cash"
                label="Saldo Presentes"
                value={cashback.presentes}
                onChange={(event) =>
                  changed({ presentes: event.target.values.floatValue })
                }
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2}>
            <Grid item sm={3}>
              <InputText
                label="Número da Venda"
                value={cashback.numero_venda}
                onChange={(event) =>
                  changed({ numero_venda: event.target.value })
                }
              />
            </Grid>
            <Grid
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              item
              sm={3}
            >
              <InputText
                fullWidth
                select
                label="Tipos de uso"
                value={cashback.tipo}
                onChange={(event) => changed({ tipo: event.target.value })}
                margin="dense"
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              >
                <option value={0}> Cashback </option>
                <option value={1}> Presentes </option>
              </InputText>
            </Grid>
            <Grid item sm={3}>
              <InputMask
                type="cash"
                label="Valor p/ Uso."
                value={cashback.valor}
                onChange={(event) =>
                  changed({ valor: event.target.values.floatValue })
                }
              />
            </Grid>
            <Grid item sm={3}>
              <InputText
                label="Senha cliente."
                value={cashback.senha}
                onChange={(event) => changed({ senha: event.target.value })}
              />
            </Grid>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" gap="8px">
          <Button
            disabled={loading ? true : false}
            color="primary"
            size="small"
            onClick={() => recieveCashback()}
          >
            Receber Cashback
          </Button>
          <Button
            disabled={loading ? true : false}
            color="secondary"
            size="small"
            onClick={() => modals({ receber: false })}
          >
            Cancelar
          </Button>
        </Box>
      </Modal>
      <Modal open={modal.enviar} width="600px">
        <Typography> Enviar cashback </Typography>
        <Grid container>
          <Grid container item spacing={2}>
            <Grid item sm={4}>
              <InputMask
                autoFocus
                label="CPF"
                format="###.###.###-##"
                type="generic"
                value={cashback.cpf}
                onChange={(event) =>
                  changed({
                    cpf: event.target.value
                      .replaceAll(".", "")
                      .replace("-", ""),
                  })
                }
                onBlur={() => consultar()}
              />
            </Grid>
            <Grid item sm={8}>
              <InputText
                disabled
                label="Nome"
                value={cashback.nome}
                onChange={(event) => changed({ nome: event.target.value })}
              />
            </Grid>
            <Grid item sm={3}>
              <InputMask
                label="Valor da venda"
                type="cash"
                value={cashback.valor}
                onChange={(e) => changed({ valor: e.target.values.floatValue })}
              />
            </Grid>
            <Grid item sm={9}>
              <InputText
                label="Número da Venda"
                value={cashback.numero_venda}
                onChange={(event) =>
                  changed({ numero_venda: event.target.value })
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" gap="8px">
          <Button
            disabled={loading ? true : false}
            color="primary"
            size="small"
            onClick={() => sendCashback()}
          >
            Enviar Cashback
          </Button>
          <Button
            disabled={loading ? true : false}
            color="secondary"
            size="small"
            onClick={() => modals({ enviar: false })}
          >
            Cancelar
          </Button>
        </Box>
      </Modal>
      <div>
        <Box display="flex" alignItems="center" gap="8px">
          <FilterBar
            searchFilter={() => pesquisar()}
            clearFilter={() => limparfiltros()}
            fullWidth
          >
            <Grid container spacing={2}>
              <Grid item sm={2}>
                <InputMask
                  label="CPF"
                  value={cashback_filtro.cpf}
                  format="###.###.###-##"
                  onChange={(e) =>
                    addFilter({
                      cpf: e.target.value.replaceAll(".", "").replace("-", ""),
                    })
                  }
                />
              </Grid>
              <Grid item sm={2}>
                <InputDate
                  label="Data de início"
                  format="dd/MM/yyyy"
                  value={cashback_filtro.data_inicial}
                  onChange={(date) => addFilter({ data_inicial: date })}
                />
              </Grid>
              <Grid item sm={2}>
                <InputDate
                  label="Data de término"
                  format="dd/MM/yyyy"
                  value={cashback_filtro.data_final}
                  onChange={(date) => addFilter({ data_final: date })}
                />
              </Grid>
              <Grid item>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Tipo</FormLabel>
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    defaultValue="top"
                  >
                    <FormControlLabel
                      value="end"
                      control={
                        <Radio
                          color="primary"
                          checked={cashback_filtro.bonus === 0}
                          onChange={(e) => addFilter({ bonus: 0 })}
                        />
                      }
                      label="Cashback"
                    />
                    <FormControlLabel
                      value="end"
                      control={
                        <Radio
                          color="primary"
                          checked={cashback_filtro.bonus === 1}
                          onChange={(e) => addFilter({ bonus: 1 })}
                        />
                      }
                      label="Presentes"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Tipo de Transação</FormLabel>
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    defaultValue="top"
                  >
                    <FormControlLabel
                      value="end"
                      control={
                        <Radio
                          color="primary"
                          checked={cashback_filtro.type_transaction === 0}
                          onChange={(e) => addFilter({ type_transaction: 0 })}
                        />
                      }
                      label="Todos"
                    />

                    <FormControlLabel
                      value="end"
                      control={
                        <Radio
                          color="primary"
                          checked={cashback_filtro.type_transaction === 1}
                          onChange={(e) => addFilter({ type_transaction: 1 })}
                        />
                      }
                      label="Entradas"
                    />

                    <FormControlLabel
                      value="end"
                      control={
                        <Radio
                          color="primary"
                          checked={cashback_filtro.type_transaction === 2}
                          onChange={(e) => addFilter({ type_transaction: 2 })}
                        />
                      }
                      label="Saidas"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </FilterBar>
          <Tooltip title="Exportar dados em xlsx">
            <Button onClick={() => exportar()}>
              <img src={excelIcon} width="32px" alt="Exportar dados em xlsx" />
            </Button>
          </Tooltip>
        </Box>

        <PerfectScrollbar>
          <DataGrid
            columns={[
              {
                title: "Empresa",
                field: "nome_fantasia",
                headerStyle: { paddingLeft: 10 },
                cellStyle: { paddingLeft: 10, whiteSpace: "nowrap" },
              },
              {
                title: "Data",
                render: (rowData) =>
                  moment(rowData.created_at).format("DD/MM/YYYY HH:mm:ss"),
                cellStyle: { whiteSpace: "nowrap" },
              },
              {
                title: "Tipo",
                render: (rowData) => renderTipo(rowData.tipo),
                cellStyle: {
                  whiteSpace: "nowrap",
                },
              },
              {
                title: "R$ Valor",
                render: (rowData) => renderValor(rowData),
                headerStyle: { padding: 0, whiteSpace: "nowrap" },
                cellStyle: {
                  padding: "8px 0",
                  width: "20px",
                  whiteSpace: "nowrap",
                },
              },
              {
                title: "Nome do cliente",
                field: "cliente_nome",
                headerStyle: { paddingLeft: 10 },
                cellStyle: {
                  paddingLeft: 10,
                  width: "300px",
                  whiteSpace: "nowrap",
                },
              },
              {
                title: "CPF Cliente",
                field: "cliente_cpf",
                headerStyle: {},
                cellStyle: {},
                hidden: ["xl"].includes(width) ? false : true,
              },
              {
                title: "R$ Venda / Número da Venda",
                field: "numero_venda",
                headerStyle: {},
                cellStyle: { whiteSpace: "nowrap" },
              },
            ]}
            data={cashback_lista}
            options={{
              headerStyle: { fontSize: "0.9rem" },
              rowStyle: { fontSize: "0.9rem" },
            }}
            actions={[
              {
                icon: () => <VisibilityIcon />,
                tooltip: "Cliente",
                onClick: (event, rowData) => {
                  setData(rowData);
                  modals({ cliente: true });
                },
              },
              {
                icon: () => <PrintIcon />,
                tooltip: "Extrato",
                onClick: (event, rowData) => {
                  setData(rowData);
                  modals({ extrato: true });
                },
              },
            ]}
          />
        </PerfectScrollbar>
        <Paginate
          rowsPerPageOptions={[10, 25, 50]}
          rowsPerPage={parseInt(cashback_perpage)}
          count={cashback_total}
          page={cashback_page - 1}
          onChangePage={(event, newPage) => handleChangePage(newPage)}
          onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
        />
      </div>
      <ModalCliente open={modal.cliente} data={data} close={modals} />
      <ModalExtrato open={modal.extrato} data={data} close={modals} />
    </Container>
  );
};

export default withWidth()(Cashback);
